import {useRef,useState,useMemo,useCallback} from "react";
import {dateFns_to_db} from '../../../core/utilities/Utilities.js';
import COMPONENT_MAP from '../Repository/Components.js';

const AccountDetailTasks=({parentId,application,userData})=>{
    const list_name='account_tasks';
    const executeQuery=useRef(true);
    const [dateFilter,setDateFilter]=useState({
        start:new Date(new Date().setDate(new Date().getDate()-new Date().getDay()+1)),
        end:new Date(new Date().setDate(new Date().getDate()-new Date().getDay()+5))
    });

    const renderFilterDate=useCallback(()=>{
        const Component=COMPONENT_MAP['FilterDate'];
        return Component?(
            <Component
                dateFilter={dateFilter}
                setDateFilter={setDateFilter}
                application={application}
                executeQuery={executeQuery}
            />
        ):null;
    },[dateFilter,application]);

    const renderListTab=useMemo(()=>{
        const Component=COMPONENT_MAP['ListTab'];
        return Component?(
            <Component
                parentId={parentId}
                application={application}
                userData={userData}
                entityType={'Task'}
                entityParams={['account_id='+parentId,"start_range="+dateFns_to_db(dateFilter.start)+" 00:00:00","end_range="+dateFns_to_db(dateFilter.end)+" 23:59:59",'_lang='+application.globalData.lang]}
                list_name={list_name}
                // height={'50vh'}
                file={'AccountDetailTasks.js'}
                initialState={{sorting:{sortModel:[{field:'planned_date',sort:'asc'}],}}}
                navigateOnNew={null}
                filterComponent={renderFilterDate()}
                executeQuery={executeQuery}
            />
        ):null; 
    },[parentId,dateFilter,application,userData,renderFilterDate]);

    return(renderListTab);
}
export default AccountDetailTasks;